import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 sm:py-14 bg-navy-light/50 relative border-y border-white/5" data-id="element-308">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-309">
        <FadeIn data-id="element-310">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-311">
            <AlertCircleIcon className="h-8 w-8 text-gold" data-id="element-312" />
            <h2 className="text-3xl sm:text-4xl font-bold text-center" data-id="element-313">
              El error que estás cometiendo
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed" data-id="element-314">
          <FadeIn delay={0.1} data-id="element-315">
            <p data-id="element-316">
              El error más común es creer que tu gato te despierta por hambre o
              por maldad. La realidad es que{' '}
              <strong className="text-gold font-semibold" data-id="element-317">
                su instinto de cazador está atrapado en un departamento de 40
                metros cuadrados.
              </strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-318">
            <p data-id="element-319">
              Gritarle, tirarle un almohadón o encerrarlo en el baño solo
              empeora el problema. Para un gato, cualquier reacción tuya
              —incluso un grito— es un premio porque logró captar tu atención.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-320">
            <div className="bg-red-900/20 border border-red-500/20 rounded-xl p-6 mt-8 text-center" data-id="element-321">
              <p className="text-red-200 font-medium" data-id="element-322">
                Lo estás entrenando para que sea un extorsionador nocturno
                profesional sin darte cuenta.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}